module.exports = __webpack_public_path__ + "static/img/20040B_7_8_C_20230526_LC.616d307.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/20040B_7_8_C_20230526_LC.png
// module id = OHiC
// module chunks = 0